import { IObject } from 'connect-store';
import * as React from 'react';
import { TextField, Button } from '@material-ui/core';
import ActionDone from '@material-ui/core/SvgIcon';

export interface ISingleInput extends React.Attributes, IObject {
  // actionIcon: JSX.Element;
  onDone: any;
  resetAfterDone: boolean;
  defaultValue: string;
  name: string;
  style: object;
}

export class SingleInput extends React.Component<ISingleInput> {

  public static defaultProps = {
    actionIcon: <ActionDone/>,
    onDone: () => null,
    resetAfterDone: true,
    defaultValue: '',
  };

  public state = {
    value: (this.props as any ).defaultValue,
    dirty: !!(this.props as any).defaultValue,
  };

  public onChangeText(e: any) {
    this.setState({
      value: e.target.value,
      dirty: true,
    });
  }

  public onDone() {
    const { value } = this.state;
    const { onDone, resetAfterDone } = this.props as any;
    onDone(value);
    if (resetAfterDone) {
      this.setState({ value: '' });
    }
  }

  public render(): JSX.Element | null {
    const { value, dirty } = this.state;
    const { actionIcon, required, containerStyle, ...others } = this.props;
    return (
      <div
        style={containerStyle}
      >
        <TextField
          {...others}
          value={value}
          onChange={this.onChangeText.bind(this)}
          onKeyDown={e => {
            if (e.keyCode === 13) {
              this.onDone();
            }
          }}
        />
        <Button
          disabled={!dirty || (required && !value)}
          onClick={this.onDone.bind(this)}
          variant={'raised'}
          size={'small'}
        >确认修改</Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/SingleInput.tsx